export const COMPLAINT_TYPE_IDS = {
  alreadySold: '62',
  duplicate: '21',
  fakeAd: '2',
  fraud: '1',
  invalidContactData: '64',
  isProfessionalSeller: '22',
  isTool: '61',
  offensiveAd: '3',
  sexual: '4',
  wrongCategory: '23',
  wrongImagesVideos: '11',
  wrongOfferType: '63',
  wrongPrice: '12',
  wrongSpec: '10'
}

export const COMPLAINT_TYPES = {
  [COMPLAINT_TYPE_IDS.alreadySold]: {
    id: COMPLAINT_TYPE_IDS.alreadySold,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.ALREADY_SOLD'
  },
  [COMPLAINT_TYPE_IDS.duplicate]: {
    id: COMPLAINT_TYPE_IDS.duplicate,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.DUPLICATE'
  },
  [COMPLAINT_TYPE_IDS.fakeAd]: {
    id: COMPLAINT_TYPE_IDS.fakeAd,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.FAKE_AD'
  },
  [COMPLAINT_TYPE_IDS.fraud]: {
    id: COMPLAINT_TYPE_IDS.fraud,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.FRAUD'
  },
  [COMPLAINT_TYPE_IDS.invalidContactData]: {
    id: COMPLAINT_TYPE_IDS.invalidContactData,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.INVALID_CONTACT_DATA'
  },
  [COMPLAINT_TYPE_IDS.isProfessionalSeller]: {
    id: COMPLAINT_TYPE_IDS.isProfessionalSeller,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.IS_PROFESSIONAL_SELLER'
  },
  [COMPLAINT_TYPE_IDS.isTool]: {
    id: COMPLAINT_TYPE_IDS.isTool,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.IS_TOOL'
  },
  [COMPLAINT_TYPE_IDS.offensiveAd]: {
    id: COMPLAINT_TYPE_IDS.offensiveAd,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.OFFENSIVE_AD'
  },
  [COMPLAINT_TYPE_IDS.sexual]: {
    id: COMPLAINT_TYPE_IDS.sexual,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.SEXUAL'
  },
  [COMPLAINT_TYPE_IDS.wrongCategory]: {
    id: COMPLAINT_TYPE_IDS.wrongCategory,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.WRONG_CATEGORY'
  },
  [COMPLAINT_TYPE_IDS.wrongImagesVideos]: {
    id: COMPLAINT_TYPE_IDS.wrongImagesVideos,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.WRONG_IMAGES_VIDEOS'
  },
  [COMPLAINT_TYPE_IDS.wrongOfferType]: {
    id: COMPLAINT_TYPE_IDS.wrongOfferType,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.WRONG_OFFER_TYPE'
  },
  [COMPLAINT_TYPE_IDS.wrongPrice]: {
    id: COMPLAINT_TYPE_IDS.wrongPrice,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.WRONG_PRICE'
  },
  [COMPLAINT_TYPE_IDS.wrongSpec]: {
    id: COMPLAINT_TYPE_IDS.wrongSpec,
    text: 'COMPLAINTS.AD_COMPLAINT_TYPES_TEXT.WRONG_SPEC'
  }
}

export const ORDERED_PRIVATE_COMPLAINT_TYPES = [
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongPrice],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongSpec],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongImagesVideos],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.duplicate],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.isProfessionalSeller],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongCategory],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.alreadySold],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.fraud],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.fakeAd],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.offensiveAd],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.sexual]
]

export const ORDERED_DEALER_COMPLAINT_TYPES = [
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongPrice],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongSpec],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongImagesVideos],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.isTool],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.wrongOfferType],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.invalidContactData],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.alreadySold],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.fraud],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.fakeAd],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.offensiveAd],
  COMPLAINT_TYPES[COMPLAINT_TYPE_IDS.sexual]
]

export const COMPLAINT_TYPES_WITH_NO_COMMENTS_FIELD = []

export const COMPLAINT_TYPES_WITH_OPTIONAL_COMMENTS_FIELD = [
  COMPLAINT_TYPE_IDS.alreadySold,
  COMPLAINT_TYPE_IDS.duplicate,
  COMPLAINT_TYPE_IDS.incorrectPhone,
  COMPLAINT_TYPE_IDS.invalidContactData,
  COMPLAINT_TYPE_IDS.isProfessionalSeller,
  COMPLAINT_TYPE_IDS.isTool,
  COMPLAINT_TYPE_IDS.wrongCategory,
  COMPLAINT_TYPE_IDS.wrongImagesVideos,
  COMPLAINT_TYPE_IDS.wrongOfferType,
  COMPLAINT_TYPE_IDS.wrongPrice,
  COMPLAINT_TYPE_IDS.wrongSpec
]

export const COMPLAINT_TYPES_WITH_OPTIONAL_USER_DATA = [COMPLAINT_TYPE_IDS.sexual]

export const COMPLAINT_TYPES_WITH_REQUIRED_USER_DATA = [
  COMPLAINT_TYPE_IDS.fakeAd,
  COMPLAINT_TYPE_IDS.fraud,
  COMPLAINT_TYPE_IDS.offensiveAd
]
